import moment from "moment";
import requestApi from "@/utils/requestApi";

export default {
  data() {
    return {
      info: {},
      date: moment().format("YYYY-MM-DD"),
      tableData: [],
    };
  },
  async created() {
    const body = document.querySelector("body");
    body.classList.add("seller-style");

    const loading = this.$loading({
      lock: true,
      text: "加载中...",
    });

    const { payCheckMonth, supplierShopId } = this.$route.query;
    const { msg, code, data } = await requestApi.post(`sctrading/purchase/purchasepaycheckrecord/selPayCheckOrderList`, {
      payCheckMonth,
      supplierShopId,
    });
    loading.close();

    if (code == "0") {
      this.info = data;
    } else {
      this.$message.error(msg);
    }
  },

  methods: {
    async confirm() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { payCheckMonth, supplierShopId } = this.$route.query;
      const { msg, code, data } = await requestApi.post(`sctrading/purchase/purchasepaycheckrecord/add`, {
        payCheckMonth,
        supplierShopId,
      });
      loading.close();

      if (code == "0") {
        this.$router.back();
      } else {
        this.$message.error(msg);
      }
    },
  },
};
